// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2ewpx","left":"StickyBox_left__IfXH-","right":"StickyBox_right__2Q78L"};